
//Profile Reducer States
export const STATE_NEW = "NEW";
export const STATE_LOADING = "LOADING";
export const STATE_LOADED = "LOADED";
export const STATE_ERROR = "ERROR";

//Filter Profile Lists Types
export const FILTER_NONE = "NONE";
export const FILTER_COUNTRY = "COUNTRY";
export const FILTER_CATEGORY = "CATEGORY";
export const FILTER_PREMIUM = "PREMIUM";
export const FILTER_SEARCH = "SEARCH";


//Actions For ProfilesList Reducer
export const ACTION_FETCH_PROFILES = "FETCH_PROFILES";
export const ACTION_FETCH_PROFILES_PENDING = "FETCH_PROFILES_PENDING";
export const ACTION_FETCH_PROFILES_FULLFILLED = "FETCH_PROFILES_FULFILLED";
export const ACTION_FETCH_PROFILES_REJECTED = "FETCH_PROFILES_REJECTED";

//Actions For ProfilePage Reducer
export const ACTION_FETCH_PROFILE = "FETCH_PROFILE";
export const ACTION_FETCH_PROFILE_PENDING = "FETCH_PROFILE_PENDING";
export const ACTION_FETCH_PROFILE_FULLFILLED = "FETCH_PROFILE_FULFILLED";
export const ACTION_FETCH_PROFILE_REJECTED = "FETCH_PROFILE_REJECTED";

//Search Actions
export const ACTION_SEARCH_PROFILES = "SEARCH_PROFILES";
export const ACTION_FILTER_PROFILES = "FILTER_PROFILES";
export const ACTION_CHANGE_PROFILES = "CHANGE_PROFILES";

export const FILTER_PAGESIZE = 24;
